module.exports = __webpack_public_path__ + "img/art5.1a087c4f.png";